export const staticLinks =
{
  firebaseBaseUrl: "https://sushant-portfolio-2ced2-default-rtdb.europe-west1.firebasedatabase.app",
  backendBaseUrl: "https://portfolio-service-ciot.onrender.com/api/v1",
  myPhoto: "https://res.cloudinary.com/sushant-thombare/image/upload/v1789586416/sushant-portfolio/Sushant_Photo_Portrait_1_eo3sxo.jpg"
};

export default { staticLinks };
